import cjson from 'compressed-json';
import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationStart, Route, Router } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import { isTemplateMiddle } from 'typescript';
import { JdDataService } from 'src/app/jd-data.service';
import _ from 'underscore';
import { withModule } from '@angular/core/testing';
import { items } from 'fusioncharts';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';

@Component({
  selector: 'app-report-skills',
  templateUrl: './report-skills.component.html',
  styleUrls: ['./report-skills.component.scss'],
  standalone: false
})
export class ReportSkillsComponent implements OnInit {

  constructor(
    private personSearchService: PersonSearchService, private location: Location, private localstorageservice: LocalStorageService,
    private router: Router, private filterDataHandlerService: FilterDataHandlerService,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private hashService: HashService
    , private talentInsightsService: TalentInsightsService,
    private jdService: JdDataService, private personsearchservice: PersonSearchService, private route: ActivatedRoute
  ) {

    const statemanagementSub = this.location.subscribe((p) => {
      const urlParams = new URLSearchParams(p.url.split('?')[1]);
      const filterKey = urlParams.get('filter');
      if (filterKey) {
        const cacheRequest = localStorage.getItem(filterKey);
        if (cacheRequest) {
          const filterData = cjson.decompress(JSON.parse(cacheRequest));
          this.filterDataHandlerService.setFilterData(filterData);
        }
      }
      this.setUpdatedData(null);

    });
  }
  skills: any;
  skillsData: any = [];
  displayedColumns: string[] = ['key', 'doc_count', 'graph', 'job_doc_count'];
  @ViewChild('skillsTbSort') skillsTbSort: MatSort;
  totalResultCount: number = 0;
  startindex: number = 0;
  aggregatescount: number = 50;
  topFiveSkills: any = [];
  apiCalled: boolean = false;
  currentPage: number = 1;
  pageSize: number = 10;
  start: number = 0;
  end: number = 10;
  totalCount: number = 0;
  talentfilterdata: any = {};
  subscriptions: Array<Subscription> = [];
  /**Sorted data of skill from pages shown */
  skillsSortData: any;
  skillsdataAI: any

  insightsExportSubscription: Subscription = null;
  titles: any[] = [];
  skillTaxonmoyPayload: any = [];
  skillsTaxonomyData: any = [];
  skillsTanomoyLoader: boolean = false;

  sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  skillsTabPayload: any
  hasJobListingAccess: any

  /**
   * Mapping of key and text value of headers
   * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
   */
  tableHeaderObj = {
    "TopSkills": "Top Skills",
    "TalentCount": "Talent Count",
    "%Total": "% of Total",
    "JobDemand": "Job Posts"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];
  showFilterMessage: boolean = false;
  combinedAggregates: any;
  combinedIndustry: any[] = [];
  combinedSkills: any[] = [];
  combinedJobtitle: any[] = [];
  combinedLocation: any[] = [];
  hasJobDemand: boolean = false;

  get isLocationEurope() {
    const hasEUTIAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    const hasEUPSAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess')

    if (!hasEUPSAccess)
      return this.localstorageservice.getItem('talentRegion') == 'europe';
  }
  filterData: any;
  aiSuggestions: any = {};
  skillsJobAggregates: any;
  filterType: string[] = [];
  isComingFromJD: Boolean = false;
  isComingFromNLSearch: Boolean = false;
  filters: any;

  ngOnInit(): void {
    if (this.jdService.isComingFromJobDescription) this.isComingFromJD = true;
    if (this.jdService.isComingFromNLSearch) this.isComingFromNLSearch = true;
    this.setUpdatedData(null);
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      this.filterData = _methodDetails;
      this.setUpdatedData()
    });
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);

    const jdUpdateEvent = this.jdService.getInsightsEvent().subscribe((res: any) => {
      if (res.action == 'refresh' && res.tab == this.talentInsightsService.INSIGHTS_TABS.SKILL) {
        this.filterType = res.filterType;
        this.setUpdatedData();
      }
    });
    this.subscriptions.push(jdUpdateEvent);

    const aiSuggestionSub = this.talentInsightsService.aiSuggesionData.subscribe(data => {
      this.aiSuggestions = data;
      if (!this.aiSuggestions) {
        this.aiSuggestions = this.talentInsightsService.getAISuggestionData();
      }
      this.setUpdatedData();
    });
    this.subscriptions.push(aiSuggestionSub);
    this.hasJobListingAccess = this.localstorageservice.getItem('hasjoblistingaccess')
  }

  fetchInsightsTabData() {
    // const skillssubscription = this.personSearchService.gettalentinsights.subscribe((response) => this.setUpdatedData(response));
    // this.subscriptions.push(skillssubscription);

  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) {
      this.talentfilterdata = talentFilterData
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.aggregatescount = 50;
    this.getSkills();
    this.personSearchService.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)

  }

  getSkills() {
    this.skillsTanomoyLoader = true;

    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "skills";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      this.apiCalled = true;
      this.totalResultCount = response.data.totalresultscount;
      const tempData = response.data.aggregations.skills;
      this.totalCount = tempData.length;
      this.skillsSortData = tempData;
      // console.log(this.skillsSortData, 'this.skillsSortData')
      this.skillsData = tempData.slice(this.start, this.end);
      this.skills = new MatTableDataSource(this.skillsData);
      this.skills.sort = this.skillsTbSort;
      this.topFiveSkills = tempData.slice(0, 5);
      if ((!this.filterData && this.filterType?.length == 0) || (this.filterData?.filterType == 'location' || this.filterData?.filterType == 'industry' || this.filterData?.filterType == 'company' || this.filterData?.filterType == 'seniority' || this.filterData?.filterType == 'function' || this.filterData?.filterType == 'locationRange' || this.filterData?.filterType == 'skills' || this.filterData?.filterType == 'jobtitle' || this.filterData?.filterType == 'keyword' || this.filterData?.filterType == 'search' || this.filterData?.filterType == 'pastjobtitle')
        || ((this.filterType?.length > 0 && (this.filterType?.includes('skills') || this.filterType?.includes('jobtitle') || this.filterType?.includes('industry') || this.filterType?.includes('company'))))) {
        this.getJobsAggregates();
      } else if (this.filterData?.filterType == 'allfilters' && !this.isComingFromJD && !this.isComingFromNLSearch) {
        this.skillsSortData.map(skills => {
          skills.job_doc_count = "0";
          return skills;
        });
      }

      else {
        this.setskillsJobAggregates();
      }

      this.manualSort();

      if (tempData.length > 0 && this.aggregatescount <= 50) {
        this.getTitles();

      } else if (this.aggregatescount <= 50) {
        this.skillTaxonmoyPayload = [];
        this.skillsTanomoyLoader = false;
      }
      this.getskillsdataai(this.skillsSortData);
    });
  }

  getTitles() {
    this.skillTaxonmoyPayload = [];
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_jobtitle';
    aggReq.startindex = 0;
    aggReq.resultsize = 10;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.titles = [];
    this.personSearchService.getTotalAggs(aggReq, true).subscribe((response) => {
      const titles = response.data?.aggregations?.[aggReq.aggregatetype];
      this.titles = _.pluck(titles, 'key');
      if (titles.length > 0 && this.aggregatescount <= 50) {
        this.getSkillTaxonomy();
        // commented for the state management
        // this.skillTaxonmoyPayload = [];
        // this.skillsTanomoyLoader = true;
      } else {
        this.skillsTanomoyLoader = false;
        this.skillTaxonmoyPayload = [];
      }
    });
  }


  getSkillPercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  manualSort() {
    this.reSortArr(this.skillsTbSort);
  }

  reSortArr(sort) {
    const tempData = this.skillsSortData;

    if (!sort || !sort.active || sort.direction === '') {
      this.skillsData = tempData.slice(this.start, this.end);
      this.skills = new MatTableDataSource(this.skillsData);
      this.skills.sort = this.skillsTbSort;
      return;
    }
    this.skillsSortData = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'graph': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'job_doc_count': return this.compare(a.job_doc_count, b.job_doc_count, isAsc);
        default: return 0;
      }
    })

    this.skillsData = this.skillsSortData.slice(this.start, this.end);
    this.skills = new MatTableDataSource(this.skillsData);
    this.skills.sort = this.skillsTbSort;
  }

  compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;

    this.manualSort();
  }


  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
  * Handel Redirection to person search listing
  * @param type
  * @param key
  */
  handelRedirection(type: string, key: string) {
    if (this.isLocationEurope) return;
    this.filters = this.filterDataHandlerService.fetchFilterData;

    const redirectFilters: Partial<FilterParams> = {
      insightsFilterData: this.filters,
    };
    switch (type) {
      case 'skills': redirectFilters['mandatoryskills'] = [key]; break;

    }



    const aggReq = this.aggService.getRequestWithFilters();
    if (aggReq?.continentstobeincluded) {
      redirectFilters['continentstobeincluded'] = aggReq.continentstobeincluded;
    }
    if (aggReq?.nlsearchquery) {
      redirectFilters['nlsearchquery'] = aggReq.nlsearchquery;
    }

    const uniqueKey = this.hashService.generateUniqueHash();
    localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

    // Forward the SAME UNIQUE_HASH this page was loaded with, so the listing page's
    // jdDataFromSession getter finds job_description-${jdUniqueHash} in the sessionStorage
    // that window.open() clones into the new tab.
    const jdUniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);

    let url = `/candidate-list?type=search&redirectSource=talent-insights&key=${uniqueKey}`;

    if ((this.isComingFromJD || this.isComingFromNLSearch) && jdUniqueHash) {
      url += `&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${jdUniqueHash}`;
    }

    window.open(url, '_blank');
  }

  getskillsdataai(data) {
    let skillsdata: any;
    skillsdata = data.map(x => {
      let res: any = {};
      res['Top Skills'] = x.key;
      res['Talent Count'] = x.doc_count;
      res['% of Total'] = this.getSkillPercentage(x.doc_count) + '%';
      res['Job Posts'] = x.job_doc_count ?? 0
      return res;

    })
    this.skillsdataAI = {
      skills: skillsdata
    }
    if (this.skillsData.length == 0)
      this.skillsdataAI = null;
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if (requestData?.data?.currentTab !== this.talentInsightsService.INSIGHTS_TABS.SKILL) return;

    this.tableHeaderName = [this.tableHeaderObj['TopSkills'], this.tableHeaderObj['TalentCount'], this.tableHeaderObj['%Total'], this.tableHeaderObj['JobDemand']];
    const skillsChart = { renderAt: 'skills', width: '100%', height: '600', type: 'sunburst', dataSource: { ...this.skillTaxonmoyPayload } };
    const skillsDataForExport = this.skillsSortData.map(skills => {
      return {
        ...skills,
        job_doc_count: skills.job_doc_count || '—',
      }
    });
    const payloadForInsightsExport = {
      tab: 'skills',
      totalresultcount: this.totalResultCount,
      skills: skillsDataForExport,
      tableHeader: this.tableHeaderName,
      chartdetails: [skillsChart],

    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getSkillTaxonomy() {
    this.showFilterMessage = false;
    this.skillTaxonmoyPayload = [];
    this.skillsTanomoyLoader = true;
    let skillsData = this.skillsSortData;
    if (this.skillsSortData.length > 50) {
      skillsData = this.skillsSortData.slice(0, 50);
    }
    const payload = {
      jobtitles: this.titles,
      skills: skillsData.map(skill => {
        return {
          skill_name: skill.key,
          skill_count: skill.doc_count
        }
      })
    }
    this.talentInsightsService.getSkillTaxonomy(payload).subscribe((response: any) => {
      if (response.status === 'success') {
        this.skillsTaxonomyData = response.data;
        const originalData = response.originalData;
        if (Object.keys(originalData['Adjacent Skills']).length === 0 || Object.keys(originalData['Core Skills']).length === 0 || Object.keys(originalData['Emerging Skills']).length === 0) {
          this.showFilterMessage = true;
          this.skillsTanomoyLoader = false;
          this.skillTaxonmoyPayload = [];
        } else {
          this.showFilterMessage = false;
          this.skillsTaxonomyData.forEach(item => {
            item['name'] = this.capitalizeFirstLetter(item.name);
            item['tooltext'] = `<span style="font-weight:600">${this.capitalizeFirstLetter(item.toolText)}</span>`;
          })

          this.skillsTanomoyLoader = false;

          this.skillTaxonmoyPayload = {
            chart: {
              showPlotBorder: "1",
              baseFontColor: "#484b59",
              tooltipcolor: "#484b59",
              innerRadius: "20",
              theme: "gammel",
              showBorder: "0",
              showLegend: "1",

              paletteColors: ['#FFE3C4', '#A3A3F7', '#95E1D3'],
              legendPosition: "bottom", // or "right"
              showLabels: "1",
              legendItemFont: "Poppins",
              labelFontSize: "12",
              labelFontColor: "#484b59",
              labelFontBold: "1",
              labelFont: "Poppins",
              toolTipFont: "Poppins",
              toolTipFontSize: "14",
              toolTipBorderColor: "ffffff",
              toolTipPadding: "5",
            },
            data: this.skillsTaxonomyData
          };
        }

      }
      else {
        console.error('Error fetching skill taxonomy:', response.message);
      }

    })
  }

  private capitalizeFirstLetter(string) {
    if (typeof string !== 'string' || string.length === 0) {
      return '';
    }
    // test engineer
    // ['test', 'engineer']
    // 'test'.chartAt(0).toUpperCase() + 'test'.splice(1) => 'Test'
    // ['Test', 'Engineer'].join(' ')
    // Test Enginner
    return string.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
  }

  getCombinedAggregates() {
    this.hasJobDemand = true;
    this.skillsSortData.map(skill => {
      skill.job_doc_count = "";
      return skill;
    });
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'jobs_base_aggregates';
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.aggregatescount = 50;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq.aggregatescount = 50;
    this.personsearchservice.getTotalAggs(aggReq).subscribe(response => {
      const tempData = response?.data?.aggregations;
      this.combinedAggregates = tempData;
      this.combinedIndustry = this.combinedAggregates['current_industry'];
      this.combinedSkills = this.combinedAggregates['skills'];
      this.combinedJobtitle = this.combinedAggregates['current_jobtitle'];
      this.combinedLocation = this.combinedAggregates['location'];
      this.getJobsAggregates();
    });
  }

  getJobsAggregates() {
    this.hasJobDemand = true;
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'skills-median_salary',
      startindex: 0,
      resultsize: 10,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
      excluded_functions: aggReq?.exclude_functions || [],
      excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
    }
    if (this.isComingFromJD || this.isComingFromNLSearch) {
      payload['jobDescriptionKeys'] = {
        jobtitles: jobtitles,
        mandatory_jobtitles: aggReq?.job_description_keys?.mandatory_job_titles || [],
        skills: skills,
        mandatory_skills: aggReq?.job_description_keys?.mandatory_skills || [],
        locations: aggReq?.job_description_keys?.locations || [],
        mandatory_locations: aggReq?.job_description_keys?.mandatory_locations || [],
        mandatory_company_sizes: aggReq?.job_description_keys?.mandatory_company_sizes || [],
        companies: aggReq?.job_description_keys?.companies || [],
        mandatory_companies: aggReq?.job_description_keys?.mandatory_companies || [],
        industries: aggReq?.job_description_keys?.industries || [],
        mandatory_industries: aggReq?.job_description_keys?.mandatory_industries || []
      }
      payload.jobtitles = _.uniq(aggReq?.jobtitles.concat(aggReq?.pastjobtitles)) || [];
      payload.skills = _.uniq(aggReq?.preferredskills?.concat(aggReq?.mandatoryskills)) || [];
    }
    this.skillsTabPayload = payload

    if (jobtitles?.length > 0 && skills?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.hasJobDemand = false;
        this.setskillsJobAggregates();
        this.getskillsdataai(this.skillsSortData);
      } else if (!this.isComingFromJD && !this.isComingFromNLSearch && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')) {
        this.hasJobDemand = false;
        this.hasJobDemand = false;
        this.setskillsJobAggregates();
        this.getskillsdataai(this.skillsSortData);
      }

      else {
        this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
          const tempData = response?.data?.aggregations['skills-median_salary'];
          this.hasJobDemand = false;
          this.skillsJobAggregates = tempData;
          this.setskillsJobAggregates();

          this.getskillsdataai(this.skillsSortData);
        });
      }

    } else {
      this.hasJobDemand = false;
      this.setskillsJobAggregates();
      this.getskillsdataai(this.skillsSortData);
    }
  }

  formatNumber(value: number): string | number {
    if (value === null || value === undefined || isNaN(value)) return '0';

    const country = this.localstorageservice.getItem('currencyCountry');
    const absNum = Math.abs(value);

    // Optional: you can fetch dynamically if you store currency symbol
    const currencySymbol = country?.toLowerCase() === 'india' ? '₹' : '$';

    const format = (num: number) => {
      return num % 1 === 0 ? num.toString() : num.toFixed(1);
    };

    if (country?.toLowerCase() === 'india') {

      if (absNum >= 1e7) { // 1,00,00,000
        return format(value / 1e7) + 'Cr';
      }

      if (absNum >= 1e5) { // 1,00,000
        return format(value / 1e5) + 'L';
      }

      if (absNum >= 1e3) {
        return format(value / 1e3) + 'K';
      }

      return value;
    }

    else {

      if (absNum >= 1e9) {
        return format(value / 1e9) + 'B';
      }

      if (absNum >= 1e6) {
        return format(value / 1e6) + 'M';
      }

      if (absNum >= 1e3) {
        return format(value / 1e3) + 'K';
      }

      return value;
    }
  }

  /**
   * Retrun true if data is still pending
   */
  getDataPendingStatus() {
    return this.hasJobDemand;
  }

  setskillsJobAggregates() {
    const aggReq = this.aggService.getRequestWithFilters();
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions')
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    if (skills?.length > 0 && jobtitles?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.skillsSortData.map(skills => {
          skills.job_doc_count = "0";
          return skills;
        });
      } else {
        this.skillsSortData.map(skills => {
          const medianSalaryData = this.skillsJobAggregates?.find(item => item.key.toLowerCase().trim() === skills.key.toLowerCase().trim());
          if (medianSalaryData) {
            skills.job_doc_count = medianSalaryData?.job_demand?.doc_count || 0;
          } else {
            skills.job_doc_count = 0;
          }
          return skills;
        });
      }

    } else {
      this.skillsSortData.map(skills => {
        skills.job_doc_count = "0";
        return skills;
      });
    }

  }

  openJoblistSlider(value: any) {
    Object.assign(this.skillsTabPayload, { mandatory_skills: [value] })
    this.sendDataToSliderSubject.next(this.skillsTabPayload);

    this.toOpenSliderFromTabSubject.next({ isOpen: true })
  }
}

